import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";
import { toDecimalString } from "../../../../../../shared/utils/numbers";

export const getColumnDefs = () => {

  const decimalFormat = (params) =>{
    if (params.value === null || params.value === undefined || params.value.length === 0) {
      return "";
    }
  
    if (typeof params.value === "string") {
      return toDecimalString(parseFloat(params.value,5));
    } else {
      return toDecimalString(params.value,5);
    }
  }

  return [
    ColumnsFactory.TextColumn("Pais", "countryName"),
    ColumnsFactory.TextColumn("Cód. Moneda", "currencyISO"),
    ColumnsFactory.TextColumn("Moneda", "currencyName"),
    ColumnsFactory.DecimalColumn("Cambio Medio", "averageRate", {ipkTotalizar: false, valueFormatter:decimalFormat}),
    ColumnsFactory.DecimalColumn("Cambio Cierre", "closingRate", {ipkTotalizar: false, valueFormatter:decimalFormat}),
    ColumnsFactory.DecimalColumn("Cambio Medio CTARDOS", "estimatedAverageRate", {ipkTotalizar: false,  valueFormatter:decimalFormat}),
    ColumnsFactory.TextColumn("Origen", "source")
  ];
};
